<template>
  <div class="allbills-log-container">
    <mytable
      :maxHeight="tableHeigth"
      :tableData="tableData"
      :myTableHeard="myTableHeard"
      :isShowOperate="isShowOperate"
      :isShowMoreOperate="isShowMoreOperate"
      :btnsMoreList="btnsMoreList"
      :btnsList="btnsList"
      :Operatewidth="0"
    ></mytable>
    <my-dialog
      diaWidth="80%"
      dialogTitle="确认把所选数据操作外发？"
      :isShowDialog="showFinanceDetail"
      @handleCloseDia="showFinanceDetail = false"
      @diaCancelBtn="showFinanceDetail = false"
      :dialogFooter="false"
    >
      <finance-detail :waybillSplitId="waybillSplitId" v-if="showFinanceDetail">

      </finance-detail>
    </my-dialog>
  </div>
</template>

<script>
import tableListNew from "@/pages/tableListNew.js"; //mixins 查询列表页公共方法
import mytable from "@/components/table/table.vue";
import MyDialog from '@/components/Dialog.vue'
import FinanceDetail from './FinanceDetail.vue';
export default {
  mixins: [tableListNew],
  components:{
    mytable,
    MyDialog,
    FinanceDetail
  },
  props: {
    waybillSplitId: {},
  },
  data() {
    return {
      align: "center",
      isShowOperate: false, //是否显示右边操作
      isShowMoreOperate: false, //是否显示右边更多操作
      // 表格右边操作按钮
      btnsList: [
        {
          name: "财务明细", //按钮名称
          methods: "financeDetail", //当前页面的方法
          param: 1, //自定义参数标记
          permission: "aaaaa",
        }
      ],
      showFinanceDetail:false,
      // 表格右边更多的操作按钮
      btnsMoreList: [
      ],
      pageGroupName: "admin_waybill_all_bill", //  页面标识
      reportFiledsNumber: "admin_waybill_all_bill", // 动态 条件、表头
    };
  },
  watch: {
    waybillSplitId: {
      handler(val) {
        if (!val) {
          this.tableData = []
        }
        this.getData({
          waybillSplitId:val
        })
      },
    },
  },
  mounted(){
    if(!this.waybillSplitId){
      return;
    }
    this.getData({
          waybillSplitId:this.waybillSplitId
    })
  },
  methods:{
    financeDetail(row){
      this.showFinanceDetail = true
    }
  }
};
</script>

<style scoped lang="less">
.allbills-log-container {
  height: 100%;
  display: flex;
  flex-flow: column;
}
</style>